/**
 * Host Context for TORI Web Agent
 *
 * Defines the identifiers that host applications must provide when embedding the widget.
 * At least one identifier must be provided.
 */

/**
 * Host context identifiers that must be provided by the embedding application.
 * At least one of these identifiers must be provided.
 */
export interface HostContext {
  /**
   * Application identifier
   */
  appId?: string;
  /**
   * Platform identifier
   */
  platformId?: string;
  /**
   * Portfolio identifier
   */
  portfolioId?: string;
}

/**
 * Validates that at least one host context identifier is provided.
 * @param context - The host context to validate
 * @returns True if at least one identifier is provided
 */
export function isValidHostContext(context: HostContext): boolean {
  return Boolean(context.appId || context.platformId || context.portfolioId);
}

/**
 * Error message displayed when no host context identifier is provided
 */
export const HOST_CONTEXT_ERROR_MESSAGE =
  'TORI requires at least one identifier: app_id, platform_id, or portfolio_id';
